// 全局捕获ResizeObserver错误
const errorHandler = window.onerror;
window.onerror = function (msg, url, lineNo, columnNo, error) {
  if (
    typeof msg === "string" &&
    (msg.includes("ResizeObserver") ||
      msg.includes("ResizeObserver loop limit exceeded") ||
      msg.includes("ResizeObserver loop completed with undelivered notifications"))
  ) {
    return true;
  }
  if (errorHandler) {
    return errorHandler(msg, url, lineNo, columnNo, error);
  }

  return false;
};

// 重写console.error以过滤ResizeObserver错误
const originalConsoleError = console.error;
console.error = function (...args) {
  if (
    args &&
    args[0] &&
    typeof args[0] === "string" &&
    (args[0].includes("ResizeObserver loop limit exceeded") ||
      args[0].includes("ResizeObserver loop completed with undelivered notifications"))
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

if (typeof window !== "undefined" && window.ResizeObserver) {
  const originalResizeObserver = window.ResizeObserver;
  const originalObserve = originalResizeObserver.prototype.observe;
  const originalUnobserve = originalResizeObserver.prototype.unobserve;
  const originalDisconnect = originalResizeObserver.prototype.disconnect;
  const resizeObserverElements = new Map();
  window.ResizeObserver = class ResizeObserver {
    private _original: any;
    private _elements: Set<Element>;
    constructor(callback: ResizeObserverCallback) {
      const debouncedCallback = (entries: ResizeObserverEntry[], observer: ResizeObserver) => {
        requestAnimationFrame(() => {
          callback(entries, observer);
        });
      };
      this._original = new originalResizeObserver(debouncedCallback);
      this._elements = new Set();
    }

    observe(target: Element, options?: ResizeObserverOptions) {
      this._elements.add(target);
      resizeObserverElements.set(this._original, this._elements);
      return originalObserve.call(this._original, target, options);
    }

    unobserve(target: Element) {
      this._elements.delete(target);
      return originalUnobserve.call(this._original, target);
    }

    disconnect() {
      this._elements.clear();
      resizeObserverElements.delete(this._original);
      return originalDisconnect.call(this._original);
    }
  };
}
